import React, { useState, useEffect } from 'react';
import DynamicBanner from '../../include/DynamicBanner';
import api from '../../../../api';
import './Transport.css';

const Transport = () => {
  const [transportData, setTransportData] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);
  
  // State to track which sections are expanded
  const [expandedRows, setExpandedRows] = useState({});

  useEffect(() => {
    const fetchTransportData = async () => {
      try {
        const response = await api.get("/api/sitepages/academic/life-and-care");
        const data = response.data.data.transport;
        
        console.log("Transport API Data:", data); // For debugging

        // Format desktop banners
        const bannerImagesDesktop =
          data.banners?.desktop?.map(img =>
            img ? `/${img.replace(/^\//, "")}` : null
          ).filter(Boolean) || [];

        // Format mobile banners
        const bannerImagesMobile =
          data.banners?.mobile?.map(img =>
            img ? `/${img.replace(/^\//, "")}` : null
          ).filter(Boolean) || [];

        setTransportData({
          ...data,
          bannerImagesDesktop,
          bannerImagesMobile
        });

        setIsLoading(false);
      } catch (err) {
        console.error("Error fetching Transport data:", err);
        setError("Failed to load Transport data");
        setIsLoading(false);
      }
    };

    fetchTransportData();
  }, []);

  const toggleSection = (sectionIndex) => {
    setExpandedRows(prev => ({
      ...prev,
      [sectionIndex]: !prev[sectionIndex]
    }));
  };

  if (isLoading) {
    return (
      <div className="text-center py-5">
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="alert alert-danger text-center m-5">
        <h4>{error}</h4>
        <button 
          className="btn btn-primary mt-3"
          onClick={() => window.location.reload()}
        >
          Try Again
        </button>
      </div>
    );
  }

  if (!transportData) {
    return (
      <div className="text-center py-5">
        <h4>No transport data available.</h4>
      </div>
    );
  }

  const {
    title,
    bannerImagesDesktop,
    bannerImagesMobile,
    content
  } = transportData;

  const { sec2_heading, transport_sections } = content || {};

  return (
    <>
      {/* ---------------- BANNER ---------------- */}
      {(bannerImagesDesktop.length > 0 || bannerImagesMobile.length > 0) && (
        <DynamicBanner
          title={title}
          bgImage={bannerImagesDesktop}
          bgImageMobile={bannerImagesMobile}
        />
      )}

      <section className="pb_80">
        <div className="container">
          <div className="row">
            <div className="sec-title text-center">
              <h2>{sec2_heading || 'Transport Route Details'}</h2>
            </div>
            
            {transport_sections && transport_sections.length > 0 ? (
              <div className="transport-sections">
                {transport_sections.map((section, sectionIndex) => {
                  const rows = section.rows || [];
                  const showReadMore = rows.length > 10;
                  const isExpanded = expandedRows[sectionIndex];
                  const displayRows = isExpanded ? rows : rows.slice(0, 10);

                  return (
                    <div key={sectionIndex} className="mb-5">
                      {/* Section Table */}
                      <div className="table-responsive mb-3">
                        <table className="table table-bordered table-hover align-middle">
                          <thead className="table-dark text-center">
                            <tr>
                              {section.columns && section.columns.map((col, colIndex) => (
                                <th key={colIndex} scope="col">{col}</th>
                              ))}
                            </tr>
                          </thead>
                          <tbody>
                            {displayRows.map((row, rowIndex) => (
                              <tr key={rowIndex}>
                                {row.map((cell, cellIndex) => (
                                  <td key={cellIndex}>{cell || '-'}</td>
                                ))}
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                      
                      {/* Read More Button */}
                      {showReadMore && (
                        <div className="text-center mb-4">
                          <button 
                            className="read-more-btn-transport"
                            onClick={() => toggleSection(sectionIndex)}
                          >
                            {isExpanded ? 'Read Less' : `Read More `}
                          </button>
                        </div>
                      )}
                    </div>
                  );
                })}
              </div>
            ) : (
              <div className="text-center py-5">
                <h4>No transport route details available at the moment.</h4>
              </div>
            )}
          </div>
        </div>
      </section>
    </>
  );
};

export default Transport;